import React from "react";
import { Paper, Grid, Snackbar as MaterialSnackbar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "./Button";
import { colors } from "../../theme";
import Image from "./svg/cookie.svg";

interface Props {
  title: string;
  text: string;
  buttonLabel: string;
  buttonDeclineLabel: string,
  onClick: () => void;
  onClickDecline: () => void;
  settings: string;
}

const useStyles = makeStyles((theme) => ({
  cookiePopup: {
    position: "fixed",
    left: "0px",
    transform: "none",
    width: "100%",
    bottom: "10px"
  },
  paper: {
    padding: "15px",
    width: "98%",
    backgroundColor: colors.COOKIE_BG,
    color: "#FFFFFF"
  },
  image: {
    margin: "10px 15px",
    float: "right"
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  text: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  button: {
    width: "170px",
    backgroundColor: colors.COOKIE_BTN,
    marginTop: "-20px",
    "&:hover": {
      backgroundColor: colors.COOKIE_BTN_HOVER,
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    }
  },
  buttonOutline: {
    width: "170px",
    backgroundColor: colors.BACKGROUND_PRIMARY,
    color: colors.COOKIE_BTN,
    marginTop: "-20px",
    "&:hover": {
      backgroundColor: colors.COOKIE_BTN_HOVER,
      color:  colors.BACKGROUND_PRIMARY
    },
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    }
  }
}));

export default function Snackbar({ title, text, buttonLabel, buttonDeclineLabel, onClick, onClickDecline, settings }: Props) {
  const classes = useStyles();

  return (
    <MaterialSnackbar open={true} className={classes.cookiePopup}>
      <Paper className={classes.paper}>
      <Grid container spacing={1}>
        <Grid item xs={2} sm={1} spacing={1} justify="center">
          <img src={Image} className={classes.image} alt="cookie"/>
        </Grid>
        <Grid item xs={10} sm={11} spacing={1}>
          <Grid container spacing={1}>
            <Grid item xs={12} className={classes.title}>
              {title}
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={8} className={classes.text}>
              <p>
                {text} 
                <a href="/settings">
                  {settings}
                </a>
              </p>
            </Grid>
            <Grid item container xs={12} sm={12} md={4}>
              <Grid item xs={6}>
                <Button className={classes.button} onClick={onClick}>{buttonLabel}</Button>
              </Grid>
              <Grid item xs={6}>
                <Button className={classes.buttonOutline} onClick={onClickDecline}>{buttonDeclineLabel}</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      </Paper>
    </MaterialSnackbar>
  );
}
